import React from 'react';

const PrivacyPolicyRU: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Введение</h2>
        <p className="mb-4">
          BIXMO SRL ("мы," "наш," или "нас") управляет мобильным приложением и веб-сайтом GatherPlay ("Сервис"). 
          Эта Политика Конфиденциальности объясняет, как мы собираем, используем и защищаем информацию при использовании нашего Сервиса.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Контактная информация:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Компания: BIXMO SRL</li>
            <li>Адрес: Кишинёв, Молдова</li>
            <li>Email: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Информация, которую мы собираем</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.1 Информация, которую мы НЕ собираем</h3>
        <p className="mb-4">
          GatherPlay создан с учётом конфиденциальности. Мы не требуем регистрации пользователя и не собираем личную информацию, такую как:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Имена, адреса электронной почты или номера телефонов</li>
          <li>Демографическая информация</li>
          <li>Данные о местоположении, кроме базовой аналитики на уровне страны</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.2 Информация, которую мы собираем</h3>
        <p className="mb-3"><strong>Автоматически собираемая информация:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Информация об устройстве:</strong> Тип устройства, версия операционной системы, версия приложения</li>
          <li><strong>Аналитика использования:</strong> Как вы взаимодействуете с приложением, используемые функции, продолжительность сессии (собирается через Amplitude)</li>
          <li><strong>Технические данные:</strong> Отчёты о сбоях и метрики производительности для улучшения стабильности приложения</li>
        </ul>

        <p className="mb-3"><strong>Локальное хранилище устройства:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>ID игрока:</strong> Случайно сгенерированный идентификатор, хранящийся локально на вашем устройстве для предотвращения повторения игровых сценариев для одного игрока</li>
          <li><strong>Игровые предпочтения:</strong> Настройки и предпочтения, которые вы настраиваете в приложении</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Как мы используем информацию</h2>
        <p className="mb-4">Мы используем собранную информацию для:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Улучшения производительности приложения и исправления ошибок</li>
          <li>Понимания того, как пользователи взаимодействуют с GatherPlay для улучшения игрового опыта</li>
          <li>Обеспечения неповторения игровых сценариев для отдельных игроков</li>
          <li>Отображения релевантной рекламы (в бесплатной версии)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Обмен и раскрытие информации</h2>
        <p className="mb-3"><strong>Сторонние сервисы:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Amplitude:</strong> Мы используем Amplitude для аналитики для понимания использования приложения и улучшения пользовательского опыта</li>
          <li><strong>Google Ads:</strong> Мы показываем рекламу через рекламную сеть Google в бесплатной версии приложения</li>
          <li><strong>Магазины приложений:</strong> Базовая статистика использования может передаваться в Apple App Store и Google Play Store как часть их стандартной аналитики</li>
        </ul>
        <p>Мы не продаём, не обмениваем и не передаём вашу информацию третьим лицам, кроме этих поставщиков услуг.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Реклама</h2>
        <p>
          В бесплатной версии GatherPlay отображается реклама от Google Ads. Эта реклама может основываться на общей 
          демографии и интересах, но не использует личную информацию, собранную из нашего приложения. Вы можете обновиться до премиум 
          версии, чтобы убрать всю рекламу через покупку в приложении.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Безопасность данных</h2>
        <p>
          Мы внедряем соответствующие технические и организационные меры для защиты информации от несанкционированного доступа, 
          изменения, раскрытия или уничтожения. Поскольку мы собираем минимум данных, ваш риск конфиденциальности значительно снижен.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Конфиденциальность детей</h2>
        <p>
          GatherPlay подходит для пользователей от 6 лет и старше. Мы сознательно не собираем личную информацию от детей. 
          Если вы родитель или опекун и считаете, что ваш ребёнок предоставил нам личную информацию, свяжитесь с нами по адресу 
          gatherplay.application@gmail.com.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Хранение данных</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Аналитические данные:</strong> Хранятся до 2 лет для анализа трендов и улучшения сервиса</li>
          <li><strong>Локальные данные устройства:</strong> Хранятся локально на вашем устройстве и могут быть очищены удалением приложения</li>
          <li><strong>Технические данные:</strong> Отчёты о сбоях и данные производительности хранятся до 1 года</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Ваши права</h2>
        <p className="mb-4">Вы имеете право:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Запросить информацию о том, какие данные мы собрали (ограничено, как описано выше)</li>
          <li>Запросить удаление ваших данных, связавшись с нами</li>
          <li>Отказаться от аналитики, отключив её в настройках вашего устройства</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Международные передачи данных</h2>
        <p>
          Наш поставщик аналитики (Amplitude) может обрабатывать данные в странах, отличных от Молдовы. Мы обеспечиваем соответствующие 
          гарантии для любых международных передач данных.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Изменения в этой Политике Конфиденциальности</h2>
        <p>
          Мы можем время от времени обновлять эту Политику Конфиденциальности. Мы уведомим вас о любых изменениях, опубликовав новую 
          Политику Конфиденциальности в приложении и обновив дату "Последнее обновление". Продолжение использования Сервиса после 
          изменений означает принятие обновлённой политики.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Свяжитесь с нами</h2>
        <p className="mb-4">Если у вас есть вопросы об этой Политике Конфиденциальности, свяжитесь с нами:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Email: gatherplay.application@gmail.com</li>
          <li>Компания: BIXMO SRL, Кишинёв, Молдова</li>
        </ul>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Эта Политика Конфиденциальности разработана для обеспечения прозрачности наших минимальных практик сбора данных при обеспечении 
          соблюдения применимых законов о конфиденциальности, включая GDPR, CCPA и требования магазинов мобильных приложений.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyRU;